<template>
  <!-- The Modal -->
  <div
    id="createModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Create Portfolio"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_en">Title «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Title En"
                        rules="required"
                      >
                        <b-form-input
                          id="name_en"
                          v-model="createdPortfolio.title"
                          name="name_en"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="title_ar">Title «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Title Ar"
                        rules="required"
                      >
                        <b-form-input
                          id="titleAR"
                          v-model="createdPortfolio.titleAR"
                          class="arabic-font"
                          name="titleAR"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                          :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="content">Content «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Content En"
                        rules="required"
                      >
                        <template>
                          <b-form-textarea
                            id="content"
                            v-model="createdPortfolio.content"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="contentAR">Content «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Content AR"
                        rules="required"
                      >
                        <template>
                          <b-form-textarea
                            id="contentAR"
                            v-model="createdPortfolio.contentAR"
                            class="arabic-font"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder=""
                            rows="5"
                            cols="12"
                            :dir="'rtl'"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="gallery">Gallery</label>
                      <validation-provider
                        #default="{ errors }"
                        name="gallery"
                        rules=""
                      >
                        <vue-dropzone
                          id="gallery"
                          ref="galleryDropzoneRef"
                          name="gallery"
                          :options="dropzoneOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import portfolioService from '@/services/porfolioService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      emailValue: '',
      title_ar: '',
      title_en: '',
      content_ar: '',
      content_en: '',
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
      createdPortfolio: {
        title: '',
        titleAR: '',
        content: '',
        contentAR: '',
        projectGallery: [],
      },
      codeBasic,
      selected: { title: 'Square' },
      option: [{ title: 'Square' }, { title: 'Rectangle' }, { title: 'Rombo' }, { title: 'Romboid' }],
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.createdPortfolio.projectGallery = this.$refs.galleryDropzoneRef.getAcceptedFiles()
          console.log(this.createdPortfolio)
          portfolioService.post(this.createdPortfolio).then(response => {
            console.log('Show error notification!', response)
            if (response && response.status === 200) {
              this.$emit('refresh', 'true')
              /* Reset Inputs */
              this.createdPortfolio = {
                title: '',
                titleAR: '',
                content: '',
                contentAR: '',
                projectGallery: [],
              }
              /* Reset Dropzone Area */
              this.$refs.galleryDropzoneRef.removeAllFiles()
              /* Close Modal */
              $('#createModal').modal('hide')

              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Success',
                  icon: 'CheckIcon',
                  variant: 'success',
                  text: 'Portfolio Is Created Successfully !',
                },
              })
            }
            /* Hide Spinner */
            this.loading = false
          }).catch(
            function (error) {
              console.log('Show error notification!', error.message)
              $('#createModal').modal('hide')
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'CheckIcon',
                  variant: 'Error',
                  text: error.message,
                },
              })
              // return Promise.reject(error)
            },
          )
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
